// apiUtils.js
export const controller = new AbortController();
export const signal = controller.signal;
